export enum ConstraintTypeEnum {
    SHIPMENT = 'SHIPMENT',
    PACKAGE = 'PACKAGE',
    COMMODITY = 'COMMODITY'
}
